/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  InputAdornment,
  IconButton,
  FormHelperText,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddIcon from '@mui/icons-material/Add';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';
import api from '../../utils/functions/api';
import TableManagementAdmin from '../../components/TableManagementAdmin';
import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../../components/Loading';

function ManagementAdmin() {
  const [isManagementAdmin, setISManagementAdmin] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState(
    dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  );
  const [endDateFilter, setEndDateFilter] = useState(
    dayjs().format('YYYY-MM-DD HH:mm:ss'),
  );
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    lastPage: 1,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMerchants, setSelectedMerchants] = useState('');
  const [merchOpt, setMerchOpt] = useState([]);
  const [openAddManagementDialog, setOpenAddManagementDialog] = useState(false);
  const [management, setManagement] = useState({
    email: '',
    mKeys: [''],
  });
  const [errors, setErrors] = useState({ email: '', mKeys: [] }); // State for error messages

  const handleManagementChange = (e) => {
    const { name, value, checked, type } = e.target;
    setManagement((prevManagement) => ({
      ...prevManagement,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const getUserList = async () => {
    try {
      setIsLoading(true);
      const token = getStorage('token');
      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/user_list`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      setISManagementAdmin(data);
      setPagination((prev) => ({
        ...prev,
        total: data.length,
        lastPage: Math.ceil(data.length / pagination.size),
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getUserList();
  }, []);

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredAdminList = isManagementAdmin.filter(
    (admin) =>
      admin.username?.toLowerCase().includes(searchText.toLowerCase()) ||
      admin.email?.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handleMerchantChange = (event, newValueMerchant) => {
    if (newValueMerchant) {
      const newMerchantIds = newValueMerchant.map((option) => option.MERCH_ID);
      setSelectedMerchants(newMerchantIds);
    } else {
      setSelectedMerchants([]);
    }
  };

  const handlePaginationChange = (event, value) => {
    if (event === 'handleChangePage') {
      setPagination({ ...pagination, currPage: value });
    } else {
      setPagination({ ...pagination, currPage: 1, size: value });
    }
  };

  const FinalConfirmationPopup = ({ open, onClose }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '400px',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            marginTop: '20px',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
          />
          บันทึกสำเร็จ !
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderRadius: '9px',
            color: '#45A6F5',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: '#E3F3FF',
            },
            margin: 'auto',
          }}
        >
          <Button onClick={onClose}>Close</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );

  const [showConfirmation, setShowConfirmation] = useState(false);

  const checkField = async () => {
    let formHasErrors = false;
    const newErrors = { email: '', mKeys: [] };

    try {
      // Ensure mkeys is an array
      let mkeyArray = Array.isArray(mKeys) ? mKeys : [mKeys];

      if (!management.email) {
        formHasErrors = true;
        newErrors.email = 'กรุณากรอกอีเมลล์';
      }

      // Check if at least one MKey is provided
      if (mkeyArray.length === 0 || mkeyArray.every((key) => !key)) {
        formHasErrors = true;
        newErrors.mKeys[0] = 'ต้องมีขั้นต่ำ 1 MKey';
      }

      mkeyArray.forEach((key, index) => {
        if (!key) {
          formHasErrors = true;
          newErrors.mKeys[index] = 'กรุณากรอก MKey';
        }
      });

      setErrors(newErrors);
      return !formHasErrors;
    } catch (error) {
      console.error('Error checking fields:', error);
      alert('Error checking fields. Please try again.');
      return false;
    }
  };

  const resetFormData = () => {
    setManagement({
      email: '',
      mKeys: [''],
    });
    setMKeys(['']);
    setErrors({ email: '', mKeys: [] }); // Reset errors
  };

  const handleCloseAddManagementDialog = () => {
    resetFormData();
    setOpenAddManagementDialog(false);
  };

  const handleAdd = async () => {
    setIsLoading(true);
    const isValid = await checkField();
    if (!isValid) {
      setIsLoading(false);
      return;
    }
    try {
      let mkeyArray = Array.isArray(mKeys) ? mKeys : [mKeys];

      let { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/add_user`,
        {
          email: management.email,
          mkey: mkeyArray,
          createBy: getStorage('username'),
        },
        {
          headers: { Authorization: getStorage('token') },
        },
      );

      if (data === 'Success') {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.error('Failed to add user:', error);
      alert('Error during add. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const [mKeys, setMKeys] = useState(['']);

  const addMKey = () => {
    setMKeys([...mKeys, '']);
  };

  const removeMKey = (index) => {
    if (mKeys.length > 1) {
      setMKeys(mKeys.filter((_, i) => i !== index));
    } else {
      alert('ต้องมีอย่างน้อย 1 MKey');
    }
  };

  const handleMKeyChange = (index, value) => {
    const newMKeys = [...mKeys];
    newMKeys[index] = value;
    setMKeys(newMKeys);
  };

  const renderFilterFormManagementAdmin = () => (
    <form>
      <Grid
        container
        alignItems="center"
        spacing={2}
        style={{ marginTop: '20px' }}
        justifyContent="space-between"
      >
        <Grid item xs={7} sm={8}>
          <TextField
            className="text"
            label="ค้นหาข้อความ :"
            variant="outlined"
            size="small"
            value={searchText}
            onChange={handleSearchTextChange}
            style={{ marginRight: '20px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ marginLeft: '20px' }}
          />
        </Grid>
        <Grid item xs={5} sm={4} container justifyContent="flex-end">
          <Button
            onClick={() => {
              setOpenAddManagementDialog(true);
            }}
            variant="contained"
            color="primary"
            size="medium"
            style={{ marginRight: '20px' }}
            startIcon={<PersonAddIcon />}
          >
            เพิ่มบัญชี
          </Button>
        </Grid>
      </Grid>

      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </form>
  );

  return (
    <Grid container>
      <Loading isLoading={isLoading} />
      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          Admin
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormManagementAdmin()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
          }}
        >
          <TableManagementAdmin
            isManagementAdmin={filteredAdminList}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
      </Grid>

      <Dialog
        open={openAddManagementDialog}
        onClose={handleCloseAddManagementDialog}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '550px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <span>เพิ่มบัญชี</span>
            <Button
              sx={{
                width: '110px',
                border: '1px solid ',
                color: '#0F4898',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(81, 210, 69, 0.1)',
                },
              }}
              onClick={addMKey}
            >
              <AddIcon sx={{ marginRight: '5px' }} /> เพิ่ม MKey
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <EmailIcon sx={{ marginRight: '20px' }} />
              <TextField
                label="อีเมลล์"
                variant="outlined"
                size="small"
                sx={{ width: '380px' }}
                value={management.email}
                onChange={(e) =>
                  setManagement((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>

            {mKeys.map((mKey, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <EnhancedEncryptionIcon sx={{ marginRight: '20px' }} />
                <TextField
                  label="MKey"
                  variant="outlined"
                  size="small"
                  value={mKey}
                  onChange={(e) => handleMKeyChange(index, e.target.value)}
                  sx={{ width: '390px' }}
                  error={!!errors.mKeys[index]}
                  helperText={errors.mKeys[index]}
                />
                <IconButton
                  sx={{
                    color: '#FC3A3A',
                    marginLeft: '20px',
                  }}
                  onClick={() => removeMKey(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </DialogContent>

        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={handleCloseAddManagementDialog}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleAdd}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default ManagementAdmin;
